import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AlwaysAuthenticatedGuard  {

  constructor(private router: Router, private route:ActivatedRoute, private authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {



        var businessID = this.authService.getTokenData().businessID;
        if(!businessID){
          this.router.navigate(['login']);
        }
  
        var first = state.url.split('/')[1];
        if(first == businessID){
        }
        else{
          this.authService.doLogOut();
        }
       

        
      

    if (!this.authService.isUserLoggedIn()) {
      //get current b
      this.router.navigate(['login']);
      return false;
    }

    return true;
  }
}
